<template>
  <div id="GreenBuildingMaterials">
    <div class="header">
      <router-link to="/Credit" replace>
        <div class="item">信用评价</div>
      </router-link>
      <router-link to="/GreenProduction" replace>
        <div class="item">绿色生产评价</div>
      </router-link>
      <router-link to="/GreenBuildingMaterials" replace>
        <div class="item actione">绿色建材认证</div>
      </router-link>
    </div>
    <div class="body">
      <el-form :inline="true" :model="form">
        <div style="display: flex; justify-content: space-evenly; flex-wrap: wrap">
          <el-form-item label="企业名称" size="small ">
            <el-input clearable v-model="form.value1" placeholder="企业名称"></el-input>
          </el-form-item>
          <el-form-item label="所属辖区" size="small ">
            <el-input clearable v-model="form.value2" placeholder="所属辖区"></el-input>
          </el-form-item>
          <el-form-item size="small ">
            <el-button type="primary" :loading="loading" @click="onSubmit">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div ref="elementRef" style="display: grid">
        <el-table v-loading="loading" v-if="elementHeight" size="small " :data="ScreeningTableData" :height="elementHeight">
          <el-table-column prop="companyName" label="企业名称"> </el-table-column>
          <el-table-column prop="cityName" label="所属辖区"> </el-table-column>
          <el-table-column prop="companyType" label="类别"> </el-table-column>
          <el-table-column prop="greenMaterialGrade" label="评价等级"> </el-table-column>
          <el-table-column prop="effectiveTime" label="有效期"> </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer">
      <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="[20, 50, 100, 300]" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination> -->
    </div>
  </div>
</template>

<script>
import * as API from '../../common/common.js'
export default {
  data() {
    return {
      form: {
        value1: '',
        value2: ''
      },
      obj: {},
      tableData: [],
      total: 400,
      pagination: {
        currentPage: 1,
        pageSize: 20
      },
      elementHeight: '',
      loading: false
    }
  },
  watch: {
    pagination: {
      handler() {
        this.GetPaging()
      },
      deep: true,
      immediate: false
    }
  },
  mounted() {
    if (this.$refs.elementRef) {
      this.elementHeight = this.$refs.elementRef.clientHeight + 'px'
    }
  },
  created() {
    this.loading = true
    API.GetDataByGreenMaterial()
      .then(({ data }) => (this.tableData = data.data))
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    ScreeningTableData() {
      return this.tableData.filter((e) => (this.obj.value1 ? String(e.companyName).includes(this.obj.value1) : true) && (this.obj.value2 ? String(e.cityName).includes(this.obj.value2) : true))
    }
  },
  methods: {
    onSubmit() {
      this.obj = { ...this.form }
      // const pagination = document.querySelector('.el-pagination')
      // const innerText = pagination.querySelector('.el-pager .active').innerText
      // if (Number(innerText) === 1) {
      //   this.GetPaging()
      // } else {
      //   const li = pagination.querySelectorAll('.el-pager .number')[0]
      //   li && li.click()
      // }
    },
    /**分页数据 */
    GetPaging() {
      console.log('页容量', this.pagination.pageSize)
      console.log('当前页', this.pagination.currentPage)
      console.log('查询条件', this.obj)
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 2000)
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.cell) {
  text-align: center;
}
#GreenBuildingMaterials {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 20px;
  .header {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    border-bottom: 1px solid #dcdcdc;
    padding-bottom: 0px;
    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 40px;
      background-color: #f2f2f2;
      border: 1px solid #dadada;
      border-bottom: none;
      border-radius: 28px 28px 0 0;
      font-weight: 600;
      font-size: 18px;
    }
    .actione {
      background-color: #007ec8;
      color: #fff;
    }
  }
  .body {
    display: grid;
    grid-template-rows: auto 1fr;
    margin: 0 20px;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
  }
}
</style>
